import { formatterPrice } from 'src/utils/formatterPrice'

import type { ProductItem } from '../types/productItem'

const MIN_INSTALLMENTS_TO_DISPLAY = 4

type ProductCardInstallmentsProps = {
  currentSku: ProductItem
}

const ProductCardInstallments = ({
  currentSku,
}: ProductCardInstallmentsProps) => {
  const {
    installments = [],
    bestInstallment,
    cashDiscountPercentage,
    price,
  } = currentSku?.sellerDefault?.sellerOffer || {}

  const notDecathlonCardInstallments = installments.filter(
    ({ onlyDecathlonCard }) => !onlyDecathlonCard
  )

  const maxInstallment = bestInstallment?.onlyDecathlonCard
    ? notDecathlonCardInstallments[notDecathlonCardInstallments.length - 1]
    : bestInstallment

  if (
    !maxInstallment ||
    maxInstallment.NumberOfInstallments < MIN_INSTALLMENTS_TO_DISPLAY
  ) {
    return null
  }

  const isInterestFree = !maxInstallment.InterestRate

  return (
    <p
      data-testid="product-card-installments"
      className="font-inter font-regular text-xs md:text-sm text-restructure-primary leading-4 md:leading-5"
    >
      ou{' '}
      {cashDiscountPercentage > 0 && (
        <span className="hidden md:inline">{formatterPrice(price)} até </span>
      )}
      {maxInstallment.NumberOfInstallments}x de{' '}
      <span className="text-restructure-action">
        {formatterPrice(maxInstallment.Value)}
        {isInterestFree && ' sem juros'}
      </span>
    </p>
  )
}

export default ProductCardInstallments
